import { SvgIconProps } from '@mui/material'
import React from 'react'

const Cancel: React.FC<SvgIconProps> = (props) => {
  return (
    <svg
      width={96}
      height={96}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx={48} cy={48} r={48} fill='#FFF4F4' />
      <g clipPath='url(#clip0_5057_207782)'>
        <path
          d='M56.2969 39.6328C55.7468 39.6328 55.3008 39.1868 55.3008 38.6367V31H41.0234C39.3757 31 38.0352 32.3405 38.0352 33.9883V45.1239C38.3633 45.0941 38.6954 45.0781 39.0312 45.0781C42.4265 45.0781 45.4658 46.6304 47.4772 49.0625H58.2891C58.8392 49.0625 59.2852 49.5085 59.2852 50.0586C59.2852 50.6087 58.8392 51.0547 58.2891 51.0547H48.7895C49.4121 52.2697 49.8136 53.6156 49.9425 55.0391H58.2891C58.8392 55.0391 59.2852 55.485 59.2852 56.0352C59.2852 56.5853 58.8392 57.0312 58.2891 57.0312H49.9425C49.6446 60.3209 47.887 63.1955 45.3238 65H60.9453C62.5931 65 63.9336 63.6595 63.9336 62.0117V39.6328H56.2969ZM58.2891 45.0781H43.6797C43.1296 45.0781 42.6836 44.6321 42.6836 44.082C42.6836 43.5319 43.1296 43.0859 43.6797 43.0859H58.2891C58.8392 43.0859 59.2852 43.5319 59.2852 44.082C59.2852 44.6321 58.8392 45.0781 58.2891 45.0781Z'
          fill='#E02A2A'
        />
        <path d='M57.293 31.5833V37.6406H63.3499L57.293 31.5833Z' fill='#E02A2A' />
        <path
          d='M39.0312 47.0703C34.088 47.0703 30.0664 51.0919 30.0664 56.0352C30.0664 60.9784 34.088 65 39.0312 65C43.9745 65 47.9961 60.9784 47.9961 56.0352C47.9961 51.0919 43.9745 47.0703 39.0312 47.0703ZM42.7238 58.3191C43.1128 58.7081 43.1128 59.3388 42.7238 59.7278C42.5294 59.9222 42.2745 60.0195 42.0195 60.0195C41.7646 60.0195 41.5097 59.9222 41.3152 59.7277L39.0312 57.4438L36.7473 59.7278C36.5528 59.9222 36.2979 60.0195 36.043 60.0195C35.788 60.0195 35.5331 59.9222 35.3387 59.7277C34.9497 59.3388 34.9497 58.7081 35.3387 58.3191L37.6226 56.0352L35.3386 53.7512C34.9496 53.3622 34.9496 52.7315 35.3386 52.3425C35.7275 51.9536 36.3583 51.9536 36.7473 52.3425L39.0312 54.6265L41.3152 52.3425C41.7042 51.9536 42.3349 51.9536 42.7239 52.3425C43.1129 52.7314 43.1129 53.3622 42.7239 53.7512L40.4399 56.0352L42.7238 58.3191Z'
          fill='#E02A2A'
        />
      </g>
      <defs>
        <clipPath id='clip0_5057_207782'>
          <rect width={34} height={34} fill='white' transform='translate(30 31)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Cancel
